module.exports = __webpack_public_path__ + "img/defaultVoucherIco.b4e1cfef.png";